(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (document.body.classList.contains('solari-menu-open')) return;
      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  // Delegate events so the drawer keeps working after a theme editor section reload.
  if (!window.solariMobileDrawerBound) {
    window.solariMobileDrawerBound = true;
    let closingTimer;
    const drawer = () => document.querySelector('[data-solari-mobile-nav][open]');
    const closeDrawer = (restoreFocus = true) => {
      const menu = drawer();
      if (!menu) return;
      clearTimeout(closingTimer);
      menu.classList.remove('is-visible');
      document.body.classList.remove('solari-menu-open');
      const trigger = menu.querySelector(':scope > summary');
      const finish = () => {
        menu.open = false;
        if (restoreFocus && trigger) trigger.focus();
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
      else closingTimer = setTimeout(finish, 280);
    };
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-solari-mobile-nav] > summary');
      if (trigger) {
        event.preventDefault();
        const menu = trigger.parentElement;
        if (menu.open) { closeDrawer(); return; }
        clearTimeout(closingTimer);
        menu.open = true;
        document.body.classList.add('solari-menu-open');
        requestAnimationFrame(() => {
          menu.classList.add('is-visible');
          menu.querySelector('.solari-mobile-nav__close')?.focus();
        });
        return;
      }
      const close = event.target.closest('.solari-mobile-nav__close, .solari-mobile-nav__backdrop');
      if (close) { closeDrawer(); return; }
      if (event.target.closest('[data-solari-mobile-nav] nav a')) closeDrawer(false);
    });
    document.addEventListener('keydown', (event) => {
      const menu = drawer();
      if (!menu) return;
      if (event.key === 'Escape') { event.preventDefault(); closeDrawer(); return; }
      if (event.key !== 'Tab') return;
      const focusable = [...menu.querySelectorAll('nav a[href], nav button:not([disabled]), nav summary')]
        .filter((item) => item.getClientRects().length > 0);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    window.addEventListener('resize', () => {
      if (window.innerWidth > 990) closeDrawer(false);
    });
    document.addEventListener('shopify:section:unload', () => {
      document.body.classList.remove('solari-menu-open');
    });
  }

  // Native details remains keyboard clickable; pointer users get the reference dropdown hover.
  if (!window.solariDesktopNavBound) {
    window.solariDesktopNavBound = true;
    const supportsHover = () => window.matchMedia('(min-width: 991px) and (hover: hover)').matches;
    document.addEventListener('pointerover', (event) => {
      if (!supportsHover() || !(event.target instanceof Element)) return;
      const item = event.target.closest('.solari-nav__dropdown');
      if (item) item.open = true;
    });
    document.addEventListener('pointerout', (event) => {
      if (!supportsHover() || !(event.target instanceof Element)) return;
      const item = event.target.closest('.solari-nav__dropdown');
      if (item && !item.contains(event.relatedTarget)) item.open = false;
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const item = document.querySelector('.solari-nav__dropdown[open]');
      if (item) { item.open = false; item.querySelector('summary')?.focus(); }
    });
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
